import type { Review } from '@/types/review';
import type { ReviewWire } from '../schemas/review';

/**
 * Convert a review from wire format to domain format.
 * Maps snake_case to camelCase and ISO timestamps to Unix milliseconds.
 */
export function mapReviewWireToDomain(wire: ReviewWire): Review {
  return {
    id: wire.id,
    checkInId: wire.check_in_id,
    userId: wire.user_id,
    content: wire.content,
    status: wire.status,
    createdAt: new Date(wire.created_at).getTime(),
    updatedAt: new Date(wire.updated_at).getTime(),
  };
}
